"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncType = {
    Simple: { TOKEN: 'Token', LOCK: 'Lock', PASSWORD: 'Password' },
    ACCOUNT: 'Account',
    TRANSACTION: 'SyncTransaction'
};
//# sourceMappingURL=SyncType.js.map